"use client";

import { useState } from "react";

import { useConfirm } from "@/components/ui/confirm";
import { isMobileDevice } from "@/utils/browser-detect";
import { isPWA } from "@/utils/helpers";
import { LocalStorageKeys } from "@/utils/local-storage-keys";

export const usePWAPrompt = () => {
  const [showPWAPrompt, setShowPWAPrompt] = useState(false);
  const { confirm } = useConfirm();

  const handlePWACancel = () => {
    setShowPWAPrompt(false);
  };

  const handlePWASkip = async () => {
    const shouldNotSkip = await confirm({
      title: "Are you sure?",
      description:
        "Installing the app provides the best experience. Continue without installing?",
      primaryCTA: "Back",
      cancelCTA: "Skip",
    });

    if (!shouldNotSkip) {
      sessionStorage.setItem(LocalStorageKeys.hasSkippedPWAInstall, "true");
      setShowPWAPrompt(false);
    }

    return shouldNotSkip;
  };

  const showPWAPromptFirst = () => {
    return (
      typeof window !== "undefined" &&
      !isPWA() &&
      !sessionStorage.getItem(LocalStorageKeys.hasSkippedPWAInstall) &&
      isMobileDevice(window.navigator.userAgent)
    );
  };

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (showPWAPromptFirst()) {
      setShowPWAPrompt(true);
    }
  };

  return {
    showPWAPromptFirst,
    showPWAPrompt,
    handlePWACancel,
    handlePWASkip,
    handleClick,
  };
};
